const IframeSizer = {
  install(Vue) {
    Vue.mixin({
      mounted() {
        if (window.parentIFrame && "autoResize" in window.parentIFrame) {
          window.parentIFrame.autoResize();
        }
      }
    });
  }
};

export default IframeSizer;
